import { loginFormToApiAdapter } from '_/adapters/loginPools/logins.adapter';
import { ILogin, ILoginForm } from '_/types/logins/logins.types';
import zeusSdk from '_/utils/SDKs';

export const fetchLoginsRequest = async (loginPoolId: string): Promise<ILogin[]> => {
  // API does not support filtering by loginPool yet, so we filter client-side
  const response = await zeusSdk.logins.list({});
  return (response.items || []).filter((item) => {
    return item.loginPoolId === loginPoolId;
  });
};

export const fetchLoginRequest = async (loginId: string): Promise<ILogin> => {
  const response = await zeusSdk.logins.get(loginId);
  return response;
};

export const createLoginRequest = async (loginPoolId: string, data: ILoginForm): Promise<ILogin> => {
  const payload = loginFormToApiAdapter(data);
  const response = await zeusSdk.logins.create({
    ...payload,
    loginPoolId: loginPoolId,
  });
  return response;
};

export const updateLoginRequest = async (loginId: string, data: ILoginForm): Promise<ILogin> => {
  const payload = loginFormToApiAdapter(data);
  const response = await zeusSdk.logins.patch(loginId, payload);
  return response;
};

export const deleteLoginRequest = async (loginId: string): Promise<void> => {
  await zeusSdk.logins.delete(loginId);
};
